<template>
  <div class="d-flex">
    <div v-for="place in detail" class="d-flex">
      <div class="px-2" v-if="place.operation">
        {{ place.operation }}
      </div>
      <div class="d-flex flex-column justify-content-center align-items-center">
        <div v-if="place.expression">
          {{ place.expression }}
        </div>
        <div v-if="place.sub" class="d-flex">
          <div v-for="sub in place.sub">
            {{sub.expression}}
          </div>
        </div>
        <div class="badge badge-light-success">
          {{ currency(place.value, false, false) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {
    FunctionLineDebugger: () => import('./FunctionLineDebugger.vue') // auto-référence
  }
})export default class FunctionLineDebugger extends Vue {

  @Prop() detail: any

  mounted(){
    console.log(this.detail)
  }
}
</script>


<style scoped>

</style>